import api from "../../Api/feathers-client";
import { convertMinToSecond } from "../../Js/TimeAndDate";

// Call backend service to get all users
export const fetchUserByClass = async (params) => {
  // fetch user's by it's uids
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find(params);
      resolve({
        status: 200,
        message: "Get User",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all tasks
export const getSettingsRecord = async (site_uuid) => {
  // fetch user's by it's uids
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").find({
        query: {
          keyid: "broadcastSettings",
          site_uuid,
        },
      });
      resolve({
        status: 200,
        message: "Get defs",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all tasks
export const upsertBroadCastRecord = async (data, site_uuid, user_id, id) => {
  // fetch user's by it's uids
  return new Promise(async (resolve, reject) => {
    try {
      let response;
      if (id) {
        response = await api.service("defs").patch(
          null,
          {
            keydata: data,
          },
          {
            query: {
              uid: id,
              keyid: "broadcastSettings",
              site_uuid,
            },
          }
        );
      } else {
        response = await api.service("defs").create(
          {
            keyid: "broadcastSettings",
            keydata: data,
            site_uuid: site_uuid,
            created_by: user_id,
            is_synced: false,
          },
          {}
        );
      }

      resolve({
        status: 200,
        message: "Get defs",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to create new podclass
export const insertPodClassData = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("pod-class").create(data, {});
      resolve({
        status: 200,
        message: "Podclass inserted",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all pod-class
export const getPodcastList = async (
  loggedInUser,
  site_uuid,
  skip,
  limit,
  filterType,
  query = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let queryObj = {};
      if (filterType == "new") {
        queryObj = {
          outcome: null,
          is_approved: false,
        };
      } else {
        queryObj = {
          outcome: {
            filename: {
              $ne: null,
            },
            approvalStatus:
              filterType == "approvalPending"
                ? null
                : filterType == "rejected"
                ? "rejected"
                : "approved",
          },
          is_approved:
            filterType == "approvalPending" || filterType == "rejected" ? false : true,
        };
      }
      console.log("queryObj", queryObj);
      let response = await api.service("pod-class").find({
        query: {
          ...query,
          verb: "newsPodcast",
          created_by: loggedInUser,
          site_uuid: site_uuid,
          ...queryObj,
          is_deleted: false,
          $sort: {
            created_at: -1,
          },
          $skip: skip,
          $limit: limit,
        },
      });

      resolve({
        status: 200,
        message: "All podclass",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected podcast
export const getPodcastInfo = async (uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("pod-class").find({
        query: {
          uid: uid,
          site_uuid: site_uuid,
          is_deleted: false,
        },
      });

      resolve({
        status: 200,
        message: "All podclass",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected podcast learners
export const getPodcastLearners = async (
  learner_ids,
  site_uuid,
  status = [true]
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find({
        query: {
          $select: [
            "uid",
            "name",
            "role_uid",
            "avatar",
            "belongs_to",
            "roll_no",
            "status",
          ],
          status: status,
          uid: {
            $in: learner_ids,
          },
          site_uuid: site_uuid,
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "All Learners",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to update assignment
export const updatePodcast = async (data, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("pod-class").patch(null, data, {
        query: {
          uid,
          site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "Podclass Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
